"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_PHONE_NUMBER = "Please enter a valid telephone number";
exports.REQUIRED_STRING = "This field is required";
exports.INVALID_EMAIL = "Please enter a valid email address.";
exports.CHOOSE_OPTION = "Please choose an option";
exports.REQUIRED_NUMBER = "This field is required";
exports.INVALID_SORT_CODE = "Please enter a valid 6 digit sort code";
exports.DRIVING_LICENCE = "Enter a valid driving licence number";
exports.VALID_MONETARY_VALUE = "Please enter a valid monetary value";
exports.ONE_VALUE_REQUIRED = "Please fill in at least 1 of these fields";
exports.INVALID_NI_NUMBER = "Please enter a valid national insurance number";
exports.VALID_ALPHANUMERIC = "Please use only numbers and letters";
exports.INVALID_BANK_ACCOUNT_NUMBER = "Please enter a valid 8 digit bank account number";
exports.INVALID_VAT_NUMBER = "Please enter a valid 9 digit VAT number";
